// LandingPage.js
import React,{ useState } from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faClipboardList, faChartLine, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { FaPhone } from "react-icons/fa6"
import { IoMdMail } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaMapMarkerAlt } from 'react-icons/fa';
import { BsLinkedin } from "react-icons/bs";
function LandingPage() {

    const [contactForm, setContactForm] = useState({
        name: "",
        email: "",
        message: "",
      });
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          const res = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              // access_key: accessKey,
              name: contactForm.name,
              email: contactForm.email,
              message: contactForm.message,
              subject: "New Contact Form Submission on Online-Permit",
            }),
          });
    
          const result = await res.json();
          // console.log("Web3Forms response:", result);
    
          if (result.success) {
            alert("Message sent successfully!");
            setContactForm({ name: "", email: "", message: "" });
          } else {
            alert("Failed to send message.");
          }
        } catch (error) {
          console.error("Error sending message:", error);
          alert("Something went wrong. Please try again.");
        }
      };
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setContactForm(prev => ({ ...prev, [name]: value }));
      };
    
    
  return (
    <div className="landing-page-container ">
      {/* Hero Section */}
      <section id="#hero" className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Make Your Workplace Safer with AI-Powered Audits</h1>
            <p>Identify risks, prevent incidents, and create a culture of safety with our comprehensive audit platform.</p>
            <div className="hero-buttons">
              <Link to="/login" className="get-started-btn">
                Get Started
              </Link>
              <a href="#features" className="learn-more-btn">
                Learn More
              </a>
            </div>
          </div>
          <div className="hero-image-container">
            <svg className="hero-image" viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg">
              <rect x="20" y="50" width="360" height="200" rx="10" fill="#EDF2F7" />
              <rect x="40" y="80" width="150" height="20" rx="4" fill="#4299E1" />
              <rect x="40" y="110" width="180" height="10" rx="2" fill="#A0AEC0" />
              <rect x="40" y="130" width="160" height="10" rx="2" fill="#A0AEC0" />
              <rect x="40" y="160" width="80" height="60" rx="4" fill="#4299E1" opacity="0.2" />
              <rect x="130" y="160" width="80" height="60" rx="4" fill="#4299E1" opacity="0.4" />
              <rect x="220" y="160" width="80" height="60" rx="4" fill="#4299E1" opacity="0.6" />
              <rect x="310" y="160" width="30" height="60" rx="4" fill="#4299E1" opacity="0.8" />
              <circle cx="320" cy="80" r="30" fill="#F56565" fillOpacity="0.2" />
              <path d="M320 65V95M305 80H335" stroke="#F56565" strokeWidth="4" strokeLinecap="round" />
            </svg>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <h2>Key Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faRobot} />
            </div>
            <h3>AI-Powered Analysis</h3>
            <p>Our system uses advanced AI to analyze safety reports and identify risk factors.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faClipboardList} />
            </div>
            <h3>Comprehensive Reporting</h3>
            <p>Create detailed safety reports with images, locations, and severity ratings.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <h3>Real-time Tracking</h3>
            <p>Track the status of safety issues from submission to resolution.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faLightbulb} />
            </div>
            <h3>Actionable Insights</h3>
            <p>Get AI-generated recommendations to improve safety measures.</p>
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section id="work" className="how-it-works-section">
        <h2>How It Works</h2>
        <div className="how-it-works-grid">
          <div className="how-it-works-card">
            <div className="step-number">1</div>
            <h3>Submit Report</h3>
            <p>Document safety concerns with detailed descriptions and optional photos.</p>
          </div>
          <div className="how-it-works-card">
            <div className="step-number">2</div>
            <h3>AI Analysis</h3>
            <p>Our AI analyzes the report to assess risk level and recommend actions.</p>
          </div>
          <div className="how-it-works-card">
            <div className="step-number">3</div>
            <h3>Track Progress</h3>
            <p>Monitor the status of your reports and any comments or updates.</p>
          </div>
          <div className="how-it-works-card">
            <div className="step-number">4</div>
            <h3>Resolution</h3>
            <p>Receive confirmation when safety issues are resolved and implemented.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to improve workplace safety?</h2>
          <p>Join organizations that are already using our platform to create safer environments for their employees and customers.</p>
          <a href="/login" className="get-started-cta-btn">
            Get Started Today
          </a>
        </div>
      </section>
{/* Contact Form */}
<section
      className="py-20 bg-gradient-to-br from-blue-50 via-white to-indigo-50"
      id="Contact"
    >
      <div className="container mx-auto px-6" id="contact">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
          Get in Touch
        </h2>
        <div className="max-w-3xl mx-auto">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={contactForm.name}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={contactForm.email}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={contactForm.message}
                onChange={handleInputChange}
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-medium transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/30"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Safety Audit </h3>
            <p className="text-gray-400">
            Make Your Workplace Safer with AI-Powered Audits.
            </p>
            <div className="flex space-x-4 mt-4 justify-center">
              <a
                href="https://in.linkedin.com/company/thesafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 hover:text-blue-800 transition-colors"
              >
                <BsLinkedin className="w-6 h-6" />
              </a>

              <a
                href="https://www.facebook.com/thesafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-700 transition-colors"
              >
                <FaFacebook className="w-6 h-6" />
              </a>

              <a
                href="https://twitter.com/thsafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ffffff] hover:text-[#daf1ff] transition-colors"
              >
                <FaXTwitter className="w-6 h-6" />
              </a>  

              <a
                href="https://www.youtube.com/channel/UCfBqBnuUfcMlORvhBaft7yA"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#f14d4d] hover:text-red-800 transition-colors"
              >
                <FaYoutube className="w-6 h-6" />
              </a>  

              <a
                href="https://api.whatsapp.com/send/?phone=917665231743&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#40db62] hover:text-green-800 transition-colors"
              >
                <FaWhatsapp className="w-6 h-6" />
              </a>  
              <a
                href="https://www.instagram.com/thesafetymaster_tsm/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-700 hover:text-pink-800 transition-colors"
              >
                <FaInstagram className="w-6 h-6" />
              </a>  



              <a
                href="info@thesafetymaster.com"
                className="text-[#D44638] hover:text-red-600 transition-colors"
              >
                {/* <Mail className="w-6 h-6" /> */}
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a
                   href="#home"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#features"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                 href="#work"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  How it Works
                </a>
              </li>
              <li>
                <a
                  href="#Contact"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className='flex flex-col '>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <a href="mailto:info@thesafetymaster.com" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <IoMdMail className="w-4 h-5 mr-2 text-white" />
            <p>info@thesafetymaster.com</p>
          </a>
              <a href="tel:+917665231743" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <FaPhone className="w-3 h-4 mr-2 text-white" />
            <p>+91 7665231743</p>
          </a>
           {/* Phone Number 2 */}
           <a href="tel:+919413882016" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <FaPhone className="w-3 h-4 mr-2 text-white" />
            <p>+91 9413882016</p>
          </a>
          {/* Address */}
         <a
          href="https://www.google.com/maps/search/?q=Unit+No+221,+Sunsquare+Plaza+Complex,+2nd+%26+4th+Floor,+450-451-452,+SPL1%2FJ,+RIICO+Chowk,+Bhiwadi,+Rajasthan+301019"
        target="_blank"
        rel="noopener noreferrer"
         className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500 mt-4"
       >
    <FaMapMarkerAlt className="w-8 h-10 mr-2 text-white" />
    <p>Unit No 221-445-450-451-452-453, 2nd & 4th Floor, Sunsquare Plaza Complex, RIICO Chowk, Bhiwadi, Rajasthan 301019</p>
  </a>
            </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.thesafetymaster.com/privacy-policy/"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
            <p className="text-gray-400 mt-4">
              &copy; {new Date().getFullYear()} TSM Digitech. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
    </div>
  );
}

export default LandingPage;